module.exports = __webpack_public_path__ + "img/union.d48b1fff.svg";